import { styled } from '@mui/material';
import { ListPage } from 'shared/react-admin/Pages';

export const ListPageStyled = styled(ListPage)({
  '& .MuiPaper-root': {
    overflow: 'auto',
  },
});
